import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
import { v4 as uuid } from 'uuid';
var errorCollector = new Map();
export var CLEAN_UP_TIMEOUT = 120 * 1000; // 2min

var scheduleCleanup = function scheduleCleanup(key) {
  setTimeout(function () {
    errorCollector.delete(key);
  }, CLEAN_UP_TIMEOUT);
};

// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
export var startCaptureGraphQlErrors = function startCaptureGraphQlErrors() {
  var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : uuid();
  errorCollector.set(key, []);
  scheduleCleanup(key);
  return key;
};
export var stopCaptureGraphQlErrors = function stopCaptureGraphQlErrors(key) {
  var errors = errorCollector.get(key);
  errorCollector.delete(key);
  return errors || [];
};
export var captureErrors = function captureErrors(errors, meta) {
  if (errors) {
    errorCollector.forEach(function (value, key) {
      errorCollector.set(key, [].concat(_toConsumableArray(value), [{
        errors: errors,
        meta: meta
      }]));
    });
  }
};
export var isUnauthenticated = function isUnauthenticated(errors) {
  if (errors.length > 0) {
    return errors.some(function (error) {
      return error.message.startsWith('Auth category: UNAUTHENTICATED');
    });
  }
  return false;
};